import { useUserStore } from '@/stores/user.js';

export function subscribeToCustomerNotifications(onGeneralNotification) {
    const userStore = useUserStore();
    
    // Protección: validar que el store y los datos necesarios estén disponibles
    if (!userStore?.profile?.customer_code) {
        console.warn('No se puede suscribir a notificaciones del cliente: customer_code no disponible');
        return null;
    }
    
    // Validar que window.Echo esté disponible
    if (!window.Echo) {
        console.error('Laravel Echo no está inicializado. No se puede suscribir al canal de notificaciones del cliente.');
        return null;
    }
    
    const customerCode = userStore.profile.customer_code;
    const channelName = `${customerCode}`;

    try {
        const channel = window.Echo.channel(channelName)
            .listen('.general.notification', (event) => {
                console.log('General notification:', event);
                onGeneralNotification?.(event); // Llamar directamente al callback
            });

        // Guarda el nombre del canal por si lo necesitas luego
        channel.name = channelName;

        return channel;
    } catch (error) {
        console.error('Error al suscribirse al canal de notificaciones del cliente:', error);
        return null;
    }
}

export function unsubscribeFromCustomerNotifications(channel) {
    if (!channel?.name) {
        console.warn('No se puede desuscribir: canal no válido');
        return;
    }
    
    // Validar que window.Echo esté disponible
    if (!window.Echo) {
        console.warn('Laravel Echo no está disponible. No se puede desuscribir del canal de notificaciones del cliente.');
        return;
    }
    
    try {
        window.Echo.leave(channel.name);
        console.log(`Desconectado del canal ${channel.name}`);
    } catch (error) {
        console.error('Error al desuscribirse del canal de notificaciones del cliente:', error);
    }
}
